/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';
import { useMemo } from 'react';
import { CopyButton } from './CopyButton';

interface propsInterface {
  values: number[][],
  methods: {
    convertDECtoHEX: (decimal: number) => string
  }
}

export const ScaleGradation = React.memo<propsInterface>((props) => {
  const mappingColor = useMemo((): string[] => props.values.map((rgb) => {
    return ` #${props.methods.convertDECtoHEX(rgb[0])}${props.methods.convertDECtoHEX(rgb[1])}${props.methods.convertDECtoHEX(rgb[2])}`;
  }), [props.values]);
  return (
    <>
      <div className='p-app-scale-block'>
        <div className='__scale-panel' style={{
          backgroundImage: `linear-gradient(90deg,${
            props.values.map((rgb) => {
              return ` rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
            })
          })`
        }}>
        </div>
      </div>
      <div className='p-app-code-inspect'>
        <pre className='__code-wrap'>
          <code className='__code'>
            {
              `linear-gradient(90deg,${mappingColor});`
            }
          </code>
        </pre>
        <span className='__button-wrap'>
          <CopyButton 
            currentColor={
              {
                gradation: mappingColor,
                hex: null,
                rgb: null
              }
            }
            scaleType={'gradation'}
          />
        </span>
      </div>
    </>
  )
});